/**
 * Preview Launch Page — admin lands here after clicking "Vista previa como
 * gestor / proveedor". URL: /preview/launch?token=<preview-jwt>
 *
 * Behaviour:
 *   1. Read the JWT, decode its `role` (no signature verify; only routing).
 *   2. Persist the token to sessionStorage (`preview_token`) so AuthContext
 *      picks it up. sessionStorage is per-tab → the admin's original tab is
 *      untouched.
 *   3. Force a full reload of the role-appropriate portal so AuthContext
 *      re-initialises with the preview JWT.
 *
 * Destinations:
 *   gestor          → /remesas
 *   payment_agent   → /provider
 *   ticket_provider → /provider
 *
 * The token is short-lived (30 min, server-side `exp`). Closing the tab ends
 * the session naturally; no logout call is needed.
 */
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const decodeRole = (jwtToken) => {
  try {
    const payload = JSON.parse(atob(jwtToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.role || null;
  } catch {
    return null;
  }
};

const DEST_FOR_ROLE = {
  gestor: '/remesas',
  payment_agent: '/provider',
  ticket_provider: '/provider',
};

const GestorPreviewLaunchPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      navigate('/login', { replace: true });
      return;
    }
    const role = decodeRole(token);
    const dest = DEST_FOR_ROLE[role] || '/remesas';
    window.sessionStorage.setItem('preview_token', token);
    window.history.replaceState({}, '', dest);
    window.location.replace(dest);
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center" data-testid="preview-launch-loading">
        <div className="spinner w-10 h-10 mx-auto mb-3" />
        <p className="text-sm text-slate-600">Abriendo vista previa…</p>
      </div>
    </div>
  );
};

export default GestorPreviewLaunchPage;
